// removed by extract-text-webpack-plugin
module.exports = {"nf-new-org-form":"nf-new-org-form","nf-button":"nf-button"};


//////////////////
// WEBPACK FOOTER
// ./src/components/forms/EditOrganizationForm/EditOrganization.scss
// module id = 5387
// module chunks = 1